import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

import Image from "./Image"
import FavoriteIcon from "./FavoriteIcon"
import Swatches from "./Swatches"
import Price from "./Price"

import styles from "./productTile.module.scss"
import { trackEvent } from "../helpers"


const ProductTile = ({ index, style, filteredColor, customStyles, origin }) => {

  // Sort skus in backward alphabetical order by color, filter out skus without PLP image
  const skus = style.skus
    .filter(sku => sku.images.plp.length > 0)
    .sort((a,b) => b.color.localeCompare(a.color))

  // Set displayed sku based on filtered color, otherwise use first sku
  const [selectedSku, setSelectedSku] = useState(skus.find(s => s.colorFamily === filteredColor) || skus[0])

  const [selectedColor, setSelectedColor] = useState(selectedSku.color)

  const updateSelectedSku = sku => {
    setSelectedColor(sku.color)
  }

  useEffect(() => {
    // For gift cards use the $100 sku
    if (style.title === "Digital Gift Card")
      setSelectedSku(skus.find(s => s.color === "100"))
  }, [style.title, skus])

  useEffect(() => {
    setSelectedSku(skus.find(s => s.color === selectedColor) || skus[0])
  }, [skus, selectedColor])
  
  const handleTileClick = e => {
    trackEvent("PLP", "Click", "Grid Item")
    if (window && window.hasOwnProperty("heap"))
      window.heap.track("Click Collection Grid Item", {
        position: index,
        product: style.title,
        color: selectedSku.color,
        path: window.location.pathname,
      })
  }

  return (
    <li
      role="presentation"
      onClick={handleTileClick}
    >
      <Link
        to={`${style.url}?color=${selectedSku.color}&origin=${origin}-${index+1}`}
        className={styles.imageLink}
      >
        <Image
          image={{
            desktopImage: (style.productType === "Handbag") ?
              selectedSku.images.plp.find(image => image.search(/front/i) > -1)
              : (style.title === "Shoe Cube Duo") ?
              selectedSku.images.plp.find(image => image.search(/front/i) > -1)
              : (style.title.includes("Anklet")) ?
              selectedSku.images.plp.find(image => image.search(/front/i) > -1)
              :
              selectedSku.images.plp.find(image => image.search(/side/i) > -1)
                || selectedSku.images.plp[0],
            mobileImage: (style.productType === "Handbag") ?
              selectedSku.images.pdp.find(image => image.search(/front/i) > -1)
              : (style.title === "Shoe Cube Duo") ?
              selectedSku.images.pdp.find(image => image.search(/pdp_3/i) > -1)
              :
              selectedSku.images.pdp.find(image => image.search(/side/i) > -1)
                || selectedSku.images.pdp[0],
          }}
          altText={style.title}
          options={{
            sizing: "plp",
          }}
          className={styles.image}
        />
        {selectedSku.images.plp[1] &&
          <Image
            image={{
              desktopImage: (style.title === "Shoe Cube Duo") ?
                selectedSku.images.plp.find(image => image.search(/back/i) > -1)
                : (style.title.includes("Anklet")) ?
                selectedSku.images.plp.find(image => image.search(/side/i) > -1)
                :
                selectedSku.images.plp.find(image => image.search(/slant/i) > -1)
                  || selectedSku.images.plp[1],
              mobileImage: (style.title === "Shoe Cube Duo") ?
                selectedSku.images.pdp.find(image => image.search(/pdp_4/i) > -1)
                :
                selectedSku.images.pdp.find(image => image.search(/slant/i) > -1)
                  || selectedSku.images.pdp[1],
            }}
            altText={style.title}
            options={{
              sizing: "plp",
            }}
            className={styles.imageHover}
          />
        }
      </Link>
      <div className={styles.info}>
        <h4 className={styles.title}>
          <Link to={`${style.url}?color=${selectedSku.color}&origin=${origin}-${index+1}`}>{style.title.split(" - ")[0]}</Link>
        </h4>
        <p className={styles.price}>
          <Price
            price={selectedSku.variants[0].price}
            compareAtPrice={selectedSku.variants[0].compareAtPrice}
          />
        </p>
        {skus.length > 1 &&
          <Swatches
            skus={skus}
            selectedSku={selectedSku}
            updateSelectedSku={updateSelectedSku}
            customStyles={customStyles}
          />
        }
        <FavoriteIcon
          sku={selectedSku.sku}
          style={style}
          className={styles.favoriteBtn}
        />
      </div>
    </li>
  )
}

export default ProductTile
